import React, { useEffect, useState, useRef } from "react";
import FilterComponent from "../FilterComponent/FilterComponent";
import "./ChannelsAndPacksComponent.css";
import HdIcon from "../hd-icon.svg";
import SdIcon from "../sd-icon.svg";
import RightIcon from "../right-icons.svg";
import FilterIcon from "../filter-icon.svg";
// import defaultBox from "../../../images/img/default-box.png";
import defaultChannel from "../default-channel.png";
import apiService from "../../../Services/apiServices";
import PackDescriptionComponent from "../PackDesription/PackDescriptionComponent";

import ScrollerWithArrows from "../../../CommonUtils/AddRemovePacksChannels/Utils/ScrollerWithArrows";
import $ from "jquery";
import _ from 'lodash';
export default function ChannelsAndPacksComponent(props) {
  //todo pack description component pending
  //todo onClick of view channel list component toggle PackDescription Componrnt with props
  //constants or variables
  const {
    channelsProps,
    packsProps,
    filters,
    selectedLanguagesProps,
    allLanguagesProps,
    selectedGenresProps,
    allGenresProps,
    filterTag,
    filterToggle,
    onClickSubmit,
    tag,
    code,
    text_data,
    selectedHd,
    prioratizePacks,
    showMaximumChat,
    preSelectedChannels,
    preSelectedPacks,
    explorePacks,
    hideConfirm,
    onSelectionChange,
  } = props;

    let explorePacksCheck = explorePacks|| false
     
  const channelRef = useRef(null);
  const packsRef = useRef(null);
  const confirmRef = useRef(null);
  const startingRef = useRef(null);
  //states

  const [applyFilterToggle, setApplyFilterToggle] = useState(false);
  const [channels, setChannels] = useState(channelsProps);
  const [packs, setPacks] = useState(packsProps);
  const [count, setCount] = useState(0);
  const [refresh, setRefres] = useState(false);
  const [selectedGenres, setSelectedGenres] = useState(selectedGenresProps);
  const [selectedLanguages, setSelectedLanguages] = useState(
    selectedLanguagesProps
  );
  const [allGenres, setAllGenres] = useState(allGenresProps);
  const [allLanguages, setAllLanguages] = useState(allLanguagesProps);
  const [enableDescriptionComponent, setEnableDescriptionComponent] = useState({
    toggle: false,
    data: null,
  });
  const [selectedPacks, setSelectedPacks] = useState([]);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [disabled, setDisabled] = useState(true);

  const [lastIndexChannel, setLastIndexChannel] = useState(
    channelsProps?.length - 1
  );

  const [lastIndexPacks, setLastIndexPacks] = useState(packsProps.length - 1);

  const [showChannelLeft, setShowChannelLeft] = useState(false);

  const [showChannelRight, setShowChannelRight] = useState(
    channelsProps?.length > 3 ? true : false
  );

  const [showPackLeft, setShowPackLeft] = useState(false);

  const [showPackRight, setShowPackRight] = useState(
    packsProps.length > 1 ? true : false
  );

  const [hasInitializedChannels, setHasInitializedChannels] = useState(false);
const [hasInitializedPacks, setHasInitializedPacks] = useState(false);
const [expandedGenres, setExpandedGenres] = useState({});

const toggleGenres = (packId) => {
  setExpandedGenres((prev) => ({
    ...prev,
    [packId]: !prev[packId],
  }));
};


// Preselect channels
useEffect(() => {
  if (!hasInitializedChannels && channelsProps?.length > 0) {
    setHasInitializedChannels(true);
    const selectedNames = preSelectedChannels.map((c) => c.name);
    const temp = channelsProps.map((channel) => ({
      ...channel,
      checked: selectedNames.includes(channel.name),
    }));
      //  setChannels(temp);
    setChannels((prev) => temp);

  }
}, [channelsProps, preSelectedChannels]);

useEffect(() => {
  if (!hasInitializedPacks && packsProps?.length > 0) {
    setHasInitializedPacks(true);
    const selectedPackNames = preSelectedPacks.map((p) => p.name);
    const temp = packsProps.map((pack) => ({
      ...pack,
      checked: selectedPackNames.includes(pack.name),
    }));
    // setPacks(temp);
    setPacks((prev) => temp);

  }
}, [packsProps, preSelectedPacks]);


  //useEffects
  useEffect(() => {
    //map through all channels and set a checked filed as false
    //map through all packs and set a checked filed as false
    channels?.map((chan) => (chan.checked = false));
  }, []);

  useEffect(() => {
    packs?.map((pa) => (pa.checked = false));
  }, []);

  useEffect(() => {
    if (props.onSelectionChange) {
      const selectedChannels = channels?.filter(c => c.checked) || [];
      const selectedPacks = packs?.filter(p => p.checked) || [];
      props.onSelectionChange(selectedChannels, selectedPacks);
    }
  }, [channels, packs]);

  var selectedpackToSend = [];
  var selectedChannelsTosend = [];

  useEffect(() => {
    let selectedChannels =
      (channels &&
        channels?.filter((oneChannel) => oneChannel.checked === true)) ||
      [];
    let selectedpacks =
      (packs && packs?.filter((onePack) => onePack.checked === true)) || [];
    if (selectedChannels?.length === 0 && selectedpacks?.length === 0) {
      setDisabled((prev) => true);
      
    } else {
      setDisabled((prev) => false);

      selectedpackToSend = packs
        .filter((onePAck) => onePAck.checked === true)
        .map((onePack) => onePack.name);

      selectedChannelsTosend = channels
        .filter((oneChannel) => oneChannel.checked === true)
        .map((oneChannel) => oneChannel.name);
    }
  }, [channels, packs]);

  

  //functions
  const handleApplyFilters = () => {
    setApplyFilterToggle(!applyFilterToggle);
  };
  const onClickChannelHandler = (channel) => {
    var temp = [];
    if (channel.checked === false) {
      channel.checked = true;
      temp = channels.map((oneChannel) =>
        oneChannel.name === channel.name ? channel : oneChannel
      );
    } else {
      channel.checked = false;
      temp = channels.map((oneChannel) =>
        oneChannel.name === channel.name ? channel : oneChannel
      );
    }
   
   setChannels((prev) => temp);
    // setChannels(temp);
  };

  const isSupportedImage = (imageLink) => {
    console.log(imageLink, "image link");
    if (imageLink.toString().includes(".gif")) {
      return imageLink;
    } else {
      return imageLink;
    }
  };

  const onPackClickHandler = (pack) => {
    var temp = [];
    if (pack.checked === false) {
      pack.checked = true;
      temp = packs.map((onePack) =>
        onePack.name === pack.name ? pack : onePack
      );
    } else {
      pack.checked = false;
      temp = packs.map((onePack) =>
        onePack.name === pack.name ? pack : onePack
      );
    }

    
    setPacks((prev) => temp);
    // setPacks(temp);
  };

  const onConfirmHandler = () => {
    console.log("onConfirmHandler", code, tag);

    let tempselectedPacks = packs
      .filter((onePAck) => onePAck.checked === true)
      .map((onePack) => onePack);

    let tempselectedChannels = channels
      .filter((oneChannel) => oneChannel.checked === true)
      .map((oneChannel) => oneChannel);

    setSelectedChannels(tempselectedChannels);
    setSelectedPacks(tempselectedPacks);
    if (tempselectedPacks.length === 0 && tempselectedChannels.length === 0) {
      return;
    }

    onClickSubmit(
      code,
      // {
      //   channelName: channels
      //     .filter((oneChannel) => oneChannel.checked === true)
      //     .map((oneChannel) => oneChannel.name),
      //   packName: packs
      //     .filter((onePAck) => onePAck.checked === true)
      //     .map((onePack) => onePack.name),
      // },
      JSON.stringify({
        channelName: channels
          .filter((oneChannel) => oneChannel.checked === true)
          .map((oneChannel) => oneChannel.name),
        packName: packs
          .filter((onePack) => onePack.checked === true)
          .map((onePack) => onePack.name),
      }),
      tag
    );

    filterToggle(true);

    localStorage.setItem(
      "selectedChannelsPAcks",
      JSON.stringify({
        channelName: tempselectedChannels,
        packName: tempselectedPacks,
      })
    );
  };

  const updateCount = (data) => {
    setCount(data);
    setRefres(!refresh);
  };

  const onClickFilterHandler = (code, data, tag) => {
    setApplyFilterToggle(false);
    apiService.inputPostResonse(code, data).then((response) => {
      const targetEntry = response?.data?.chatResponse?.entries.find(
        (entry) => entry?.uiCommand === "A59"
      );
      var tempChannels = [];
      var tempPacks = [];
      tempChannels =
        targetEntry?.text_data?.channels?.channelList;

      tempChannels !== undefined &&
        tempChannels.map((chan) => (chan.checked = false));
      tempPacks =
        targetEntry?.text_data?.packsWithChannel
          ?.packList;

      tempPacks !== undefined && tempPacks.map((pa) => (pa.checked = false));
      //  var tempChannels=[]
      //  var tempPacks=[]
      //   tempChannels=response.data.chatResponse.entries[1].text_data?.channels?.channelList
      //   tempPacks=response.data.chatResponse.entries[1].text_data?.packsWithChannel?.packList
      //take tempChannels -> response.data.chatResponse.entries[1].text_data?.channels?.channelList
      //take tempPacks -> response.data.chatResponse.entries[1].text_data?..packsWithChannel?.packList
      //mapthrough channels and packs and add checked as false
      //TODO - Bharath - localLanguagesAndGenre update here as per Conversation component post function

      console.log(
        targetEntry?.text_data,
        "HERE IN CHANNELS AND PACKS"
      );
      // setChannels(tempChannels);
      setChannels((prev) => tempChannels);
      // setPacks(tempPacks);
      setPacks((prev) => tempPacks);
      setAllLanguages(
        targetEntry?.text_data?.filter?.language
          ?.listOfLanguages
      );
      setSelectedLanguages(
        targetEntry?.text_data?.filter?.language
          ?.selectedLanguages
      );
      setAllGenres(
        targetEntry?.text_data?.filter?.genre
          ?.listOfGenre
      );
      setSelectedGenres(
        targetEntry?.text_data?.filter?.genre
          ?.selectedGenre
      );
      setRefres(!refresh);
      setRefres(!refresh);
    });
  };

  const enableDescription = (e, data) => {
        e?.stopPropagation?.();
  
    if (data) {
      localStorage.setItem("packDescription", JSON.stringify(data));
      setEnableDescriptionComponent({
        toggle: true,
        data,
      });
    }
  };
  

  const selectDescription = (data) => {
    onPackClickHandler(enableDescriptionComponent.data);
    setEnableDescriptionComponent({
      toggle: false,
      data: null,
    });
  };

  useEffect(() => {
    if (channels && channels.length > 0) {
      const element = document.getElementById("hscrollChannels");
  
      const handleScroll = _.throttle(() => {
        let container = $(".channelsSliderContainer");
        let containerRect = container[0]?.getBoundingClientRect();
        if (!containerRect) return;
  
        let visibleStart = containerRect.left;
        let visibleEnd = containerRect.left + containerRect.width;
  
        let lastCard = $(`#channelId-${lastIndexChannel}`)[0];
        let firstCard = $(`#channelId-0`)[0];
  
        if (!lastCard || !firstCard) return;
  
        let lastCardRect = lastCard.getBoundingClientRect();
        let firstCardRect = firstCard.getBoundingClientRect();
  
        setShowChannelRight(!(lastCardRect.right <= visibleEnd && lastCardRect.left >= visibleStart));
        setShowChannelLeft(firstCardRect.left < visibleStart);
      }, 100);
  
      element?.addEventListener("scroll", handleScroll);
  
      // Run once on mount
      handleScroll();
  
      return () => {
        element?.removeEventListener("scroll", handleScroll);
      };
    }
  }, [channels, lastIndexChannel]);
  

  const getScrollValue = _.throttle(() => {
    let container = $(".packsSilderContainer");
    let containerRect = container[0].getBoundingClientRect();
    let containerLeft = containerRect.left;
    let containerWidth = containerRect.width;

    let visibleStart = containerLeft;
    let visibleEnd = containerLeft + containerWidth;

    let lastCardElement = $(`#packId-${packs.length - 1}`);
    let lastCardRect = lastCardElement[0].getBoundingClientRect();
    let lastCardLeft = lastCardRect.left;
    let lastCardRight = lastCardLeft + lastCardRect.width;

  
    if (lastCardRight > visibleStart && lastCardLeft < visibleEnd) {
      setShowPackRight(false); 
    } else {
      setShowPackRight(true);
    }

    let firstCardElement = $(`#packId-0`);
    let firstCardRect = firstCardElement[0].getBoundingClientRect();
    let firstCardLeft = firstCardRect.left;

    setShowPackLeft(firstCardLeft < visibleStart); 
  }, 100); 


  useEffect(() => {
    if (packs !== undefined && packs !== null && packs.length !== 0) {
      const element = document.getElementById("hscrollPacks");
      element.addEventListener("wheel", getScrollValue , { passive: true });

      return () => {
        element.removeEventListener("wheel", getScrollValue , { passive: true });
      };
    }
  }, [packs, getScrollValue]);

  return (
    <div>
      {enableDescriptionComponent.toggle && (
        <PackDescriptionComponent
          data={enableDescriptionComponent.data}
          closeDescriptionComponent={() => setEnableDescriptionComponent(false)}
          selectDesctipon={() => selectDescription()}
          showMaximumChat={showMaximumChat}
          explorePacksCheck={explorePacksCheck}
        />
      )}
      {/* <div className="applyFilterContainer" ref={startingRef}>
        {applyFilterToggle && count > 0 && (
          <div key={count} id="filterCount">
            {count}
          </div>
        )}
        <div className="buttonContainer btn-animate chat-label action-tab">
          <img src={FilterIcon}></img>
          <span onClick={() => handleApplyFilters()}>Apply Filters</span>
        </div>
      </div> */}
      {/* {applyFilterToggle && <div className="filterContainer-packList">
        {applyFilterToggle ? (
          <FilterComponent
            filters={props?.filters}
            selectedLanguagesProps={selectedLanguages}
            allLanguagesProps={allLanguages}
            selectedGenresProps={selectedGenres}
            allGenresProps={allGenres}
            onClickFilter={onClickFilterHandler}
            filterTag={filterTag}
            filterToggle={filterToggle}
            setCount={updateCount}
            code={localStorage.getItem("filterCode")}
            selectedHd={selectedHd}
          />
        ) : null}
      </div>} */}
      <div
        style={{
          display: "flex",
          width: "99%",
          flexDirection: "column",
          paddingLeft: "1%",
        }}
      >
        {
          <div className="channelsListContainer">
            {(
              channels !== undefined &&
              channels !== null &&
              channels.length !== 0
            ) && (
              <div className="channelsHeaderContainer">
                <p>Channels</p>
                <span></span>
              </div>
            )}
            {channels !== undefined &&
              channels !== null &&
              channels.length !== 0 && (
                <ScrollerWithArrows
                  dontShow={channels?.length === 0}
                  width="100%"
                  height="12rem"
                  isShowLeft={showChannelLeft}
                  isShowRight={showChannelRight}
                  setShowLeft={setShowChannelLeft}
                  setShowRight={setShowChannelRight}
                  lastIndex={lastIndexChannel}
                  parentId="hscrollChannels"
                  childId="channelId"
                  minimumValue={100}
                  maximumValue={105}
                  showMaximumChat={showMaximumChat}
                >
                  <div
                    className="channelsSliderContainer"
                    id="hscrollChannels"
                    ref={channelRef}
                    width="100%"
                  >
                    {channels !== undefined &&
                    channels !== null &&
                    channels.length !== 0 ? (
                      channels.map((oneChannel, index) => (
                        <div
                          id={`channelId-${index}`}
                          key={index}
                          className="oneChannelBox action-tab"
                          onClick={() => onClickChannelHandler(oneChannel)}
                          style={{
                            border: oneChannel.checked
                              ? "1px solid #F07FC8"
                              : "none",
                            width: "30%",
                            position: "relative",
                          }}
                        >
                          {oneChannel.language && (
                            <div className="channel-lang-info" onClick={(e) => e.stopPropagation()}>
                              <span className="channel-lang-icon">ⓘ</span>
                              <div className="channel-lang-tooltip"><span>Language : {oneChannel.language}</span> <span style={{marginTop : '10px'}}>HD/SD  : {oneChannel?.hd_SD}</span> </div>
                    
                            </div>
                          )}
                          {!explorePacksCheck && <div className="oneChannel-checkbox">
                            <input
                              type="checkbox"
                              value={oneChannel.name}
                              checked={oneChannel.checked}
                            ></input>
                          </div>}
                          <div className="oneChannel-nameLogo">
                            <img
                              src={oneChannel.imageLink}
                              onError={(e) => (e.target.src = defaultChannel)}
                            ></img>
                            <p style={{display : 'flex' , justifyContent : 'center'}}>{oneChannel.name} <div style={{marginLeft : '4px'}}>({oneChannel.channelNo})</div></p>
                            
                          </div>
                          <div className="oneChannel-priceContainer">
                            <p>{oneChannel.description}</p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No Channels</p>
                    )}
                  </div>
                </ScrollerWithArrows>
              )}
          </div>
        }
        {
          <div className="packsListContainer">
            {(packs !== undefined && packs !== null && packs.length !== 0 && !explorePacksCheck) &&(
             <div className="packsList-header">
             <p>Packs with the channel</p>
             <span></span>
           </div>
            ) }
            {packs !== undefined && packs !== null && packs.length !== 0 && (
              <ScrollerWithArrows
                dontShow={packs?.length === 0}
                width="100%"
                height="14rem"
                isShowLeft={showPackLeft}
                isShowRight={showPackRight}
                setShowLeft={setShowPackLeft}
                setShowRight={setShowPackRight}
                lastIndex={lastIndexPacks}
                parentId="hscrollPacks"
                childId="packId"
                minimumValue={240}
                maximumValue={950}
                showMaximumChat={showMaximumChat}
              >
                <div
                  className="packsSilderContainer"
                  id="hscrollPacks"
                  ref={packsRef}
                >
                  {packs.length !== 0 ? (
                    packs.map((onePack, index) => (
                      <div
                        key={index}
                        id={`packId-${index}`}
                        className="onePackBox action-tab"
                        onClick={() => !explorePacksCheck && onPackClickHandler(onePack)}
                        style={{
                          border: onePack.checked
                            ? "1px solid #F07FC8"
                            : "none",
                          // width: "60%",
                          width : showMaximumChat && explorePacks ? '25%' : showMaximumChat? "20%" : '44%',
                         
                        }}
                      >
                        <div className="onePackBox-checkbox">
                         {!explorePacksCheck &&  <input
                            type="checkbox"
                            value={onePack}
                            checked={onePack.checked}
                            className="action-tab"
                          ></input>}
                          <p style={{fontSize :  explorePacks ? '13px' : showMaximumChat ? '12px' : '10px'}}>{onePack.name}</p>
                        </div>
                        <div className="onePackBox-price">
                          <div style={{fontSize : showMaximumChat ? '12px' : '10px'}}>{onePack.description}</div>{" "}
                        </div>
                        <div className="onePackBox-hdsd">
                          <div className="hdSdContainer">
                            <img src={HdIcon}></img>
                            <p>{onePack.noOfHdChannels}</p>
                          </div>
                          <div className="hdSdContainer">
                            <img src={SdIcon}></img>
                            <p>{onePack.noOfSdChannels}</p>
                          </div>
                        </div>
                     

                        {explorePacksCheck && (
  <div style={{ width : showMaximumChat && '82%'}} className="genre-filter-bar">
    <div className="genre-label">
      <img src={'https://help.tataplay.com/uploads/genre.svg'} alt={onePack?.genreImageLink} />
      Genre
    </div>

    <div className="genre-tags">
      {(expandedGenres[index] ? onePack?.genreList : onePack?.genreList?.slice(0, 1))?.map((genre) => (
        <li style={{fontSize : '12px'}} key={genre}>{genre}</li>
      ))}

      {onePack?.genreList?.length > 2 && (
        <button
          className="toggle-genres-btn"
          onClick={() =>
            setExpandedGenres((prev) => ({
              ...prev,
              [index]: !prev[index],
            }))
          }
        >
          {expandedGenres[index] ? '–' : '+'}
        </button>
      )}
    </div>
  </div>
)}


                        <div
                          className="onePackBox-link action-tab"
                          onClick={(e) => enableDescription(e, onePack)}
                        >
                          <p style={{fontSize : showMaximumChat ? '12px' : '10px'}}>View Channel List</p>
                          <img style={{width :'11px' , marginBottom : '4px'}} src={RightIcon}></img>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No Packs</p>
                  )}
                </div>
              </ScrollerWithArrows>
            )}
          </div>
        }
      </div>
      { !explorePacksCheck && !hideConfirm &&  <div className="confirmButtonContainer-channelsAndPacks action-button" ref={confirmRef}>
   <button
        disabled={disabled}
        className={`action-tab top-level-menu btn btn-primary btn-lg waves-effect waves-light confirm-btn ${
          disabled ? "disabled-btn" : "enabled-btn"
        }`}
        style={{
          borderRadius: "6px",
          textAlign: "center",
          fontSize: "12px",
          width:'8rem'
          // background handled in class
        }}
        onClick={() => onConfirmHandler()}
      >
      <p style={{position :'relative', top : '6px'}}>Confirm</p>
      </button>

        {/* <a
        className="action-tab top-level-menu btn btn-primary btn-lg waves-effect waves-light confirm-btn back-styling"
        style={{
          borderRadius: "20px",
          textAlign: "center",
          fontSize: "12px",
        }}>
          <p>Back</p>
        </a> */}
      </div>}
    </div>
  );
}
